<template>
  <div class="page">
    <!-- 头部 -->
    <YorkbbsHeader :width="'1170px'"></YorkbbsHeader>

    <!-- 搜索/导航 -->
    <YorkbbsSearchNav :topicVisible="false"></YorkbbsSearchNav>

    <div class="page-wrapper">
      <!-- 面包屑 -->
      <YorkbbsBreadcrumb>
        <el-breadcrumb-item to="/">约克黄页</el-breadcrumb-item>
        <el-breadcrumb-item>攻略/榜单/专题</el-breadcrumb-item>
      </YorkbbsBreadcrumb>

      <!-- 攻略/榜单/专题 -->
      <dl class="special">
        <dt class="special-header">攻略/榜单/专题</dt>
        <dd class="special-list">
          <YorkbbsSpecialItem v-for="(item, i) in specials" :key="i" :data="item"></YorkbbsSpecialItem>
        </dd>
      </dl>

      <!-- 分页 -->
      <YorkbbsPagination
        :current-page="offset"
        :page-size="size"
        :total="itemTotal"
        hide-on-single-page
        @current-change="pageChange"
      ></YorkbbsPagination>
    </div>

    <YorkbbsFooter></YorkbbsFooter>
  </div>
</template>
<script>
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsSearchNav from '../components/search-nav.vue';
import YorkbbsBreadcrumb from '@/common/breadcrumb.vue';
import YorkbbsSpecialItem from './item-special.vue';
import YorkbbsFooter from '@/common/footer/footer.vue';
import YorkbbsPagination from '@/common/pagination.vue';
import { setHtmlMeta } from '@/utils/utils';
export default {
  name: 'Special',
  components: {
    YorkbbsHeader,
    YorkbbsSearchNav,
    YorkbbsBreadcrumb,
    YorkbbsSpecialItem,
    YorkbbsFooter,
    YorkbbsPagination,
  },
  data() {
    return {
      // 专题加载状态
      loading: false,
      // 专题列表
      specials: [],
      // 页码
      offset: 1,
      // 每页显示的记录数
      size: 10,
      // 总记录数
      itemTotal: 0,
    };
  },
  created() {
    const offset = Number(this.$route.query.offset);
    this.offset = Number.isNaN(offset) ? 1 : offset;
    this.getSpecials();
  },
  methods: {
    /**
     * 获取专题列表
     */
    async getSpecials() {
      this.loading = true;
      const { data } = await this.$axios
        .post('/cms/v2/get/post/list', {
          offset: this.offset,
          size: this.size,
          sort: ['property_publishTime: DESC'],
          "options":{"cmsType":[2,3,4,6]},
        })
        .finally(() => {
          this.loading = false;
        });

      this.specials = data.items;
      this.itemTotal = data.itemTotal;
      
    },
    // 翻页
    pageChange(offset) {
      this.$router.push({ query: { ...this.$route.query, offset } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  width: 1170px;
  min-height: calc(100vh - 435px);
  margin: auto;
}

.special-header {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 30px;
}

.special-list {
  display: flex;
  flex-wrap: wrap;
}

.special-item {
  box-sizing: border-box;
  width: 50%;
  margin-bottom: 50px;
}
</style>
